/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.attendance.tracks'},
});

const TracksItem = () => (
  <RouteLinkItem
    route="midas/settings/attendance/attendance-tracks"
    title={messages.title}
  />
);

export default TracksItem;
